import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';
import { simpleClickAnimation } from '../makeADonut/makeDonutStart';
import { differentFadeIn } from './createTitle';
import { customConvertToButton } from './menuUI';

export function pause(scene) {
    scene.tweens.pauseAll();

    const rect = scene.add.rectangle(512,384,1024,768,0xfffeec,.7).setDepth(7).setInteractive().setAlpha(0);
    const pauseArr = [];
    const bttnContLeft = scene.add.container().setDepth(8);
    const bttnContRight = scene.add.container().setDepth(8);

    pauseArr.push(ABCya.Images.addImage(246, 316, "Pause Screen/Paused_P",scene).setDepth(8).setAlpha(0));
    pauseArr.push(ABCya.Images.addImage(343, 324, "Pause Screen/Paused_A",scene).setDepth(8).setAlpha(0));
    pauseArr.push(ABCya.Images.addImage(463, 327, "Pause Screen/Paused_U",scene).setDepth(8).setAlpha(0));
    pauseArr.push(ABCya.Images.addImage(577, 321, "Pause Screen/Paused_S",scene).setDepth(8).setAlpha(0));
    pauseArr.push(ABCya.Images.addImage(674, 317, "Pause Screen/Paused_E",scene).setDepth(8).setAlpha(0));
    pauseArr.push(ABCya.Images.addImage(775, 320, "Pause Screen/Paused_D",scene).setDepth(8).setAlpha(0));
    const resume = ABCya.Images.addImage(619, 491, "Pause Screen/Btn_Resume",scene).setDepth(8).setAlpha(1);
    const startOver = ABCya.Images.addImage(393, 491, "Pause Screen/Btn_StartOver",scene).setDepth(8).setAlpha(1);

    bttnContRight.add(resume);
    bttnContLeft.add(startOver);

    bttnContRight.add(scene.add.text(619,580,"RESUME",{fontFamily:'bpreplaybold',
    fontSize:'16px',
    align:'center',
    color:'#0099ad'}).setOrigin(.5,.5).setDepth(8));

    bttnContLeft.add(scene.add.text(393,580,"START OVER",{fontFamily:'bpreplaybold',
    fontSize:'16px',
    align:'center',
    color:'#0099ad'}).setOrigin(.5,.5).setDepth(8));

    pauseArr.push(bttnContRight,bttnContLeft);

    const timeline = scene.tweens.createTimeline();

    differentFadeIn(pauseArr,timeline);

    timeline.play();

    //rect.setAlpha(1);
    ABCya.Tweens.addTween(rect,800,{alpha:1});

    timeline.on('complete',()=>{
        resume.setInteractive();
        startOver.setInteractive();
    
        // customConvertToButton(resume);
        // customConvertToButton(startOver);
    })

    resume.on('pointerdown',()=>{
        //resume.disableInteractive();
        simpleClickAnimation(resume);
        let tween = pauseOut(pauseArr,rect);
        //tween.on('complete')
    });

    startOver.on('pointerdown',()=>{
        //scene.custSound.playSoundCustom('click-select-donuts');
        //startOver.disableInteractive();
        simpleClickAnimation(startOver);
        let tween = pauseOut(pauseArr,rect);
        tween.on('complete',()=>{
            scene.tweens.killAll()
            resetGamedata();
            restartAll(scene);
        });
    });
}

export function restartAll(scene)
{
    const transitionBack = ABCya.Images.addImage(512,384,"Background-01",scene).setDepth(8).setAlpha(0.01);
    
    transitionBack.setInteractive();
    ABCya.Tweens.addTween(transitionBack,500,{alpha:1},Phaser.Math.Easing.Quadratic.In(),()=>{
        scene.scene.restart()
    })
}

export function resetGamedata()
{
    gameData.makeData = {shapeUI:"",frostingUI:"",sprinkleUI:"",sprinkleCUI:"",eat:false,selected:{shape:"Ring"},sprinkle:false,index:0};
    gameData.currentDonuts = [];
    gameData.dots = [];
    gameData.questionNum = 0;
    gameData.clickedState = 0;
}

export function pauseOut(letters,rect)
{
    let tween;
    for(let c = 0; c < letters.length;c++)
    {
        if(c === letters.length-1)
        {
            tween = ABCya.Tweens.addTween(letters[c],500,{y:"+=600",delay:c*10},Phaser.Math.Easing.Quadratic.In(),()=>{letters[c].destroy()});
        }
        else
        {
            ABCya.Tweens.addTween(letters[c],500,{y:"+=600",delay:c*10},Phaser.Math.Easing.Quadratic.In(),()=>{letters[c].destroy()}); 
        }
    }
    let t = ABCya.Tweens.addTween(rect,500,{alpha:0});
    t.on('complete',()=>{
        rect.scene.tweens.resumeAll();
        rect.destroy();
    });

    return tween;
}